import React from 'react';
import { Box } from '../../../../../../base/Box/Box';
import { TabCarouselCardStoryblok } from '../../../../../../types/storyblok';
import * as Tabs from '@radix-ui/react-tabs';
import { Type } from '../../../../../../base/Type/Type';
import Markup from '../../../../../../base/Markup/Markup';
import Link from '../../../../../../base/Link/Link';
import renderStoryblokComponents from '../../../../../../utils/renderStoryblokComponents';
import { StoryblokImage } from '../../../../../../base/StoryblokImage/StoryblokImage';

export const TabCarouselCard = ({
  _uid,
  tabTitle,
  image,
  heading,
  description,
  logos,
  linkTitle,
  link,
}: TabCarouselCardStoryblok) => {
  if (!tabTitle && !heading && !description && !logos && !linkTitle && !link) {
    return null;
  }

  return (
    <Tabs.Content value={_uid}>
      <Box
        as="div"
        className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-10 lg:gap-20 mt-[72px]"
        overlayOverBkg
      >
        <Box as="div">
          <StoryblokImage
            src={image}
            mode="responsive"
            maxWidth={1000}
            alt={heading}
            className="rounded"
          />
        </Box>
        <Box as="div" className="flex flex-col justify-between">
          <Box as="div" className="mb-4">
            <Type as="h3" className="mb-4 font-helvetica text-h2 lg:mb-7">
              {heading}
            </Type>
            <Markup content={description} className="text-p1" />
          </Box>
          <Box as="div" className="mt-8">
            <Box
              as="div"
              className="mb-8 flex flex-row flex-wrap gap-6 md:gap-12"
            >
              {renderStoryblokComponents({ blocks: logos })}
            </Box>
            <Link href={link} variant="primary">
              {linkTitle}
            </Link>
          </Box>
        </Box>
      </Box>
    </Tabs.Content>
  );
};

export default TabCarouselCard;
